import {FC} from 'react';

import Button from '@/shared/components/button';

import RegisterMembersCard from '../RegisterMembersCard';
import {LOGIN_MEMBERS_CARD} from './consts';

interface MembersSectionProps {
  handleSignInWithEmail: () => void;
}

const MembersSection: FC<MembersSectionProps> = ({handleSignInWithEmail}) => {
  return (
    <section className="flex flex-col items-center gap-12 bg-light-primary px-4 py-14 sm:gap-14 sm:px-12 sm:py-20">
      <h3 className="text-center font-bold text-3xl leading-tight max-sm:text-2xl">
        From a Bump to Forever
      </h3>
      <div className="grid items-start gap-12 sm:grid-cols-2 sm:gap-8 xl:flex">
        {LOGIN_MEMBERS_CARD.map((card) => (
          <RegisterMembersCard
            key={card.name}
            image={card.image}
            text={card.text}
            name={card.name}
            firstCode={card.firstCode}
            secondCode={card.secondCode}
          />
        ))}
      </div>
      <Button
        onClick={handleSignInWithEmail}
        variant="primary"
        size="standard"
        className="w-full max-w-96"
      >
        Try Now
      </Button>
    </section>
  );
};

export default MembersSection;
